<template>
  <div class="screenshotPanel">
    <div class="panel-top">
      <span class="title">截图列表</span>
    </div>
    <div class="list">
      <div
        v-for="(item, idx) in clipImages"
        :key="idx"
        class="list-item"
      >
        <div
          class="img-item"
          @click="preview(item)"
        >
          <!-- :src="getBlobUrl(item.blob)" style="max-height: 100%;max-width: 100%;"-->
          <img
            draggable="false"
            style="max-height: 100%;max-width: 100%;"
            :src="getBlobUrl(item.blob)"
            @load="loadimage"
          >
          <div
            class="del-icon-btn"
            @click.stop="delItem(idx)"
          >
            <iconfont
              class="icon-normal"
              style="font-size:12px;"
              name="#icon12-12shanchu"
            ></iconfont>
            <iconfont
              class="icon-hover"
              style="font-size:12px;"
              name="#icon12-12shanchujiaohu"
            ></iconfont>
          </div>
        </div>
        <div class="img-title">
          <textShowTip
            :text="item.name"
            :css-object="{ padding: '2px 6px' }"
          ></textShowTip>
        </div>
      </div>
    </div>
    <div class="panel-bottom">
      <div
        class="del-btn"
        @click="clearAll"
      >
        <iconfont
          class="icon-normal"
          name="#icon12-12shanchu"
          style="font-size:16px;margin:0 6px 0 0;"
        ></iconfont>
        <iconfont
          class="icon-hover"
          name="#icon12-12shanchujiaohu"
          style="font-size:16px;margin:0 6px 0 0;"
        ></iconfont>
        <span>清空列表</span>
      </div>
    </div>
    <div
      v-if="!(clipImages.length > 0)"
      class="blank-page"
    >
      <span>还没有任何作品哦</span>
      <div class="mask"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
    TextShowTip: () => import('@/components/common/textShowTip')
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters({
      clipImages: 'screenshot/clipImages'
    })
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    //this.$modal.show('previewImageModal',{aaa:1});
    this.$store.commit('screenshot/clearClipImages');
  },
  methods: {
    clearAll() {
      this.$modal.show('MessageDialog', {
        content: '是否确定要清空当前的列表内容？（操作不可恢复）',
        btns: ['Cancel', 'Ok', 'Close'],
        size: { width: 478, height: 184 },
        resultHandler: (value) => {
          if (value && value.type == 'Ok') {
            this.$store.commit('screenshot/clearClipImages');
          }
        }
      });
    },
    getBlobUrl(b) {
      return window.URL.createObjectURL(b);
    },
    delItem(idx) {
      //console.log('delItem', idx);
      this.$modal.show('MessageDialog', {
        content: '是否确认删除该文件？',
        btns: ['Cancel', 'Ok', 'Close'],
        size: { width: 478, height: 184 },
        resultHandler: (value) => {
          if (!value) return;
          if (value && value.type == 'Ok') {
            this.$store.commit('screenshot/removeImageIndex', idx);
          }
        }
      });
    },
    preview(item) {
      this.$modal.show('previewImageModal', { url: this.getBlobUrl(item.blob) });
    },
    loadimage(e){
      if(e && e.target && e.target.offsetHeight){
        if(e.target.offsetHeight < 146) {
          e.target.style.marginTop = `${(147-e.target.offsetHeight)/2}px`;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.screenshotPanel {
  position: relative;
  width: 326px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: white;
  box-shadow: 0px 10px 20px 0px rgba(90, 98, 179, 0.1);
  * {
    user-select: none;
  }
  .panel-top {
    flex-shrink: 0;
    height: 50px;
    line-height: 30px;
    .title {
      margin: 29px 0 0 33px;
      float: left;
      height: 16px;
      line-height: 16px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #343434;
    }
  }
  .list {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .list-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 200px;
      width: 260px;
      .img-item {
        background: #f2f4f8;
        border: 0.5px solid #d7d7d7;
        border-radius: 4px;
        box-shadow: 0px 6px 10px 0px rgba(23, 52, 136, 0.06);
        position: relative;
        margin: 24px 0 0 0;
        height: 147px;
        width: 100%;
        &:hover {
          cursor: pointer;
          .del-icon-btn {
            visibility: visible;
          }
        }
        .del-icon-btn {
          display: flex;
          visibility: hidden;
          justify-content: center;
          align-items: center;
          position: absolute;
          width: 30px;
          height: 30px;
          background: #ffffffbb;
          box-shadow: 0px 3px 10px 0px rgba(90, 98, 179, 0.18);
          border-radius: 15px;
          right: 5px;
          top: 5px;
          &:hover {
            background: #ffffff;
            visibility: visible;
            cursor: pointer;
            .icon-hover {
              display: block;
            }
            .icon-normal {
              display: none;
            }
          }
          .icon-hover {
            display: none;
          }
        }
      }
      .img-title {
        width: 240px;
        height: 16px;
        margin: 12px 0 0 0;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }
  }
  .panel-bottom {
    flex-shrink: 0;
    height: 50px;
    .del-btn {
      margin-right: 33px;
      float: right;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #343434;
      .icon-hover {
        display: none;
      }
      &:hover {
        cursor: pointer;
        .icon-hover {
          display: block;
        }
        .icon-normal {
          display: none;
        }
      }
    }
  }
  .blank-page {
    margin: 0px 0 0 0;
    background: transparent;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    .mask {
      position: absolute;
      width: 100%;
      height: 70px;
      background: white;
      bottom: 0;
    }
  }
}
</style>
